import { ACCESS_CODES_TABLE_SORT_ENABLED, ACCESS_CODES_TABLE_SORT_DISABLED } from '../actions/access_codes_table_sort'

export const accessCodesSort = (state = { sortField: null, order: null }, action) => {
  switch (action.type) {
    case ACCESS_CODES_TABLE_SORT_ENABLED:
      return { ...state, sortField: action.sortField, order: action.order }
    case ACCESS_CODES_TABLE_SORT_DISABLED:
      return { ...state, sortField: null, order: null }
    default:
      return state
  }
}
